import {Injectable} from '@angular/core';
import {IProductService} from './product.service.interface';
import {environment} from '../../../../environments/environment';
import {ProductsResponseModel} from '../models/products-response.model';
import {firstValueFrom} from 'rxjs';
import {MyHttpClient} from '../../../shared/services/my-http-client.service';

@Injectable({
    providedIn: 'root'
})
export class ProductDealerAppService extends IProductService {

    // https://minntgmbh.atlassian.net/wiki/spaces/BROT/pages/3140190210/BROTHER+GET+Product+List+for+Project+v1
    // https://partnerapp.test.brother.de/api/v3/projectProducts
    public async getProjectProducts(projectId?: number): Promise<ProductsResponseModel> {
        // projectId si not used for dealerApp service version
        const debug = false;

       const response = await firstValueFrom(
            this.httpClient.get<ProductsResponseModel>(
                `${this.serverAddress}/v1/projectProducts`
            )
        );

        if (debug) {
            console.log('getProjectProducts', response);
            console.log('getProjectProducts', response);

            (response as any).productDistributors[0].status = 'INACTIVE';
            (response as any).productDistributors[2].status = 'INACTIVE';
            (response as any).supplyDistributors[0].status = 'INACTIVE';
            (response as any).supplyDistributors[2].status = 'INACTIVE';
            console.warn('remove product distributor status mock', response);
        }
        // this.mocksUtilsService.mockHardwareTonerInfos(response as ProductsResponseModel);
        return response;
    }
}
